
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
    root: {
        backgroundColor: "transparent"
    },
    contenido: {
        padding: "10px"
    },

})

export const ListaEnlaceBlog = ({ subItem, itemDescription, displayTitle = true }) => {
    const classes = useStyles();
    let alto=subItem.height? (subItem.height+"px") :"140px";
    let imgSize;
    if(subItem.img.includes("240px-ECOSUR.jpg")){
        imgSize = "contain";
    }
    return (
        <Card className={classes.root}>
            <CardActionArea href={subItem.url} >
                <CardMedia                    
                    image={subItem.img}
                    title={subItem.title}
                    style={{height:alto, backgroundSize:imgSize, minWidth:"240px", margin:"auto"}}
                />
                <CardContent className={classes.contenido}>
                    {
                        displayTitle &&
                        <Typography gutterBottom variant="h5" component="h2">
                            {subItem.title} 
                        </Typography>
                    }
                    <Typography variant="body2" color="textSecondary" component="p" className={classes.root}>
                    
                        {itemDescription}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>

    );
}
